var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLockGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 4.875C6.25 3.88044 6.64509 2.92661 7.34835 2.22335C8.05161 1.52009 9.00544 1.125 10 1.125C10.9946 1.125 11.9484 1.52009 12.6517 2.22335C13.3549 2.92661 13.75 3.88044 13.75 4.875V5.5H14.375C15.2038 5.5 15.9987 5.82924 16.5847 6.41529C17.1708 7.00134 17.5 7.7962 17.5 8.625V14.875C17.5 15.7038 17.1708 16.4987 16.5847 17.0847C15.9987 17.6708 15.2038 18 14.375 18H5.625C4.7962 18 4.00134 17.6708 3.41529 17.0847C2.82924 16.4987 2.5 15.7038 2.5 14.875V8.625C2.5 7.7962 2.82924 7.00134 3.41529 6.41529C4.00134 5.82924 4.7962 5.5 5.625 5.5H6.25V4.875ZM10 2.375C9.33696 2.375 8.70107 2.63839 8.23223 3.10723C7.76339 3.57607 7.5 4.21196 7.5 4.875V5.5H12.5V4.875C12.5 4.21196 12.2366 3.57607 11.7678 3.10723C11.2989 2.63839 10.663 2.375 10 2.375ZM10 13C10.3315 13 10.6495 12.8683 10.8839 12.6339C11.1183 12.3995 11.25 12.0815 11.25 11.75C11.25 11.4185 11.1183 11.1005 10.8839 10.8661C10.6495 10.6317 10.3315 10.5 10 10.5C9.66848 10.5 9.35054 10.6317 9.11612 10.8661C8.8817 11.1005 8.75 11.4185 8.75 11.75C8.75 12.0815 8.8817 12.3995 9.11612 12.6339C9.35054 12.8683 9.66848 13 10 13Z",
    fill: "#6D6262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockGray);
export default __webpack_public_path__ + "static/media/IconLockGray.f6cd4179b57e859bb781596699a99537.svg";
export { ForwardRef as ReactComponent };